import React from "react";

/**
 * The Archivist emblem — a refined magnifying glass resting over the open
 * Codex book. Drawn in the lucide-react visual style (24x24, currentColor
 * stroke, round joins) so it sits naturally beside the other nav icons.
 *
 * Accepts the same sizing pattern as lucide icons (className="h-4 w-4").
 */
export const ArchivistGlass = React.forwardRef(
  ({ size = 24, strokeWidth = 2, className = "", ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* open book — lower portion */}
      <path d="M3 14.5c1.8-1 4.2-1 6 0V20c-1.8-1-4.2-1-6 0z" />
      <path d="M9 14.5c1.8-1 4.2-1 6 0V20c-1.8-1-4.2-1-6 0z" />
      {/* magnifying glass rising from the book */}
      <circle cx="13.5" cy="8" r="4.2" />
      <line x1="16.6" y1="11.1" x2="20" y2="14.5" />
    </svg>
  )
);

ArchivistGlass.displayName = "ArchivistGlass";

export default ArchivistGlass;
